<template>
  <div>
      <Breadcrumb :headers="headers"></Breadcrumb>
    <List
      url="getFileTechnologyPartners"
      :tanle="tanle"
      :update="updateList"
      :afterList="dealGrade"
      :data="searchData"
      :isAdd="false"
      @jump="jump"
      :operat="operat">
      <div slot="Filter">
        <el-input v-model="searchData.Key" placeholder="Company" style="width:400px;"></el-input>
        <el-button @click="updateList++" type="primary" style="margin-left:10px;">Search</el-button>
      </div>
    </List>
 
  </div>
</template>

<script>
import List from "../components/common/List.vue";
import Breadcrumb from "../components/common/Breadcrumb.vue";
export default {
    components: {
        List,
        Breadcrumb
    },
    data() {
        return {
            tanle: [
                { name: "Name", label: "Logo", type:"image"},
                { name: "Company", label: "Company", type:"word"}
            ],
            headers:[{label:"Home",path:"/dashboard"},{label:"Technology Partners",path:"/technologyPartners"}],
            searchData: { Key: "" },
            updateList: 0,
            operat: []
        };
    },
    mounted() {},
    methods: {
        dealGrade (data) {
            for(let i in data) {
                data[i].Name = `${this.$http.host}akuvoxwiki/download/partnerManage/productMaterials/${data[i].Name}`;
            }
            return data;
        },
        jump(val) {
            this.$router.push(`/technologyPartnerInfo?id=${val.ID}`);
        }
    },
    computed: {},
    watch:{}
};
</script>
